export const topBarHeight = 64;
export const sideNavWidth = 280;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
export const dateFormat = 'YYYY-MM-DD';
export const ADMIN_ROLE = 101915236;
